import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Instagram, Facebook, Linkedin, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  // Handle service link click - navigate and scroll to top
  const handleServiceClick = (path) => (e) => {
    e.preventDefault();
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-grid">
          {/* Brand Section */}
          <div className="footer-section footer-brand">
            <Link to="/" className="footer-logo-link">
              <h3 className="footer-logo">GoCalFit</h3>
            </Link>
            <p className="footer-tagline">
              Serious movement. Serious play.
            </p>
            <div className="footer-social">
              <a href="https://instagram.com/gocalfit" target="_blank" rel="noopener noreferrer" className="social-link">
                <Instagram size={20} />
              </a>
              <a href="https://www.facebook.com/share/18X7CSeReN/?mibextid=LQQJ4d" target="_blank" rel="noopener noreferrer" className="social-link">
                <Facebook size={20} />
              </a>
              <a href="https://www.linkedin.com/in/carolinecutlergocalfit" target="_blank" rel="noopener noreferrer" className="social-link">
                <Linkedin size={20} />
              </a>
            </div>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-links">
              <li><a href="/bungee" onClick={handleServiceClick('/bungee')}>Bungee Fitness</a></li>
              <li><a href="/aerial" onClick={handleServiceClick('/aerial')}>Aerial Kids</a></li>
              <li><a href="/workouts" onClick={handleServiceClick('/workouts')}>Workouts</a></li>
              <li><a href="/consulting" onClick={handleServiceClick('/consulting')}>Start Here</a></li>
              <li><a href="/shop" onClick={handleServiceClick('/shop')}>Shop</a></li>
            </ul>
          </div>

          {/* Company */}
          <div className="footer-section">
            <h4 className="footer-heading">Company</h4>
            <ul className="footer-links">
              <li><Link to="/about">About Us</Link></li>
              <li><a href="/events" onClick={handleServiceClick('/events')}>Events</a></li>
              <li><a href="/gallery" onClick={handleServiceClick('/gallery')}>Gallery</a></li>
              <li><Link to="/faq">FAQ</Link></li>
              <li><Link to="/waiver">Waiver</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="footer-section">
            <h4 className="footer-heading">Get in Touch</h4>
            <ul className="footer-contact">
              <li>
                <Mail size={16} />
                <a href="mailto:hello@gocalfit.com">hello@gocalfit.com</a>
              </li>
              <li>
                <Phone size={16} />
                <a href="tel:+19104094445">(910) 409-4445</a>
              </li>
              <li>
                <MapPin size={16} />
                <a 
                  href="https://maps.google.com/?q=5060+New+Centre+Dr+Ste+70,+Wilmington,+NC+28403" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  Wilmington, NC
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            ©2026 Core Air Life Fitness | CalFit. All rights reserved.
          </p>
          <div className="footer-legal">
            <Link to="/privacy">Privacy Policy</Link>
            <span className="divider">•</span>
            <Link to="/terms">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
